import { getAsyncTypes } from '../helpers/actionType'
import log from '../helpers/logger';
import { RememberCurrent, GetCurrent } from './Persist';
const SCREEN_PREFIX = 'Plan';
const PERSIST_KEY = SCREEN_PREFIX + "_LAST_PLAN"
export const SUBMIT_PLAN = getAsyncTypes(SCREEN_PREFIX, 'SUBMIT_PLAN');
export const REMEMBER_PLAN = getAsyncTypes(SCREEN_PREFIX, 'REMEMBER_PLAN');
export const LOAD_PLAN = getAsyncTypes(SCREEN_PREFIX, 'LOAD_PLAN');
export const LOAD_PAGE = getAsyncTypes(SCREEN_PREFIX, 'LOAD_PAGE');
export const FLUSH_PLAN = getAsyncTypes(SCREEN_PREFIX, 'FLUSH_PLAN');
export const RESET = getAsyncTypes(SCREEN_PREFIX, "RESET");

const initState = {
  currentPlan: {
    // approvedAmount: 100000,
    // percentageAnnual: 2,
    // currency: '',
    // amountPicked: 50000,
    // annualFee: 1000,
    // setupFee: 500,
    // percentagePool: 5,
    // poolContribution: null,
    // amountPool: 0,
    // poolSize: 125690,
    // subtotal: null,
    // validCoupons: ['20OFF', 'FINTRUX'],
    // couponCode: '',
    // calculatedDiscount: null,
    // subtotalAfterDiscount: null,
    // taxName: 'VAT',
    // percentageTax: 5,
    // amountTax: null,
    // subtotalAfterTax: null,
    // total: null,
  }
}

// reducer
export function planReducer(state = initState, action) {
  const payload = action.payload;
  switch (action.type) {
    case RESET.SUCCEEDED:
      return initState
    case FLUSH_PLAN.SUCCEEDED:
      return initState
    case LOAD_PAGE.STARTED:
      return {
        loading: true,
      }
    case LOAD_PAGE.SUCCEEDED:
      return {
        // ...(payload.Ddl || {}),
        currentPlan: {
          ...payload.currentPlan
        },
        initialized: true,
        loading: false,
        key: Date.now(),
      }
    case SUBMIT_PLAN.STARTED:
      return {
        ...state,
        loading: true,
        // do not change version on async start
      }
    case SUBMIT_PLAN.FAILED:
      return {
        ...state,
        loading: false,
        key: Date.now() // always revise verioning failed or succeeded.
      }
    case SUBMIT_PLAN.SUCCEEDED:
      return {
        ...state,
        currentPlan: {
          ...state.currentPlan,
          ...payload,
          result: "success",

        },
        loading: false,
        key: Date.now()
      }
    case REMEMBER_PLAN.SUCCEEDED:
      return {
        ...state,
        currentPlan: {
          ...state.currentPlan,
          ...payload,
        },
        loading: false,
      }
    default:
      return state;
  }
}

// action
export function resetPlan() {
  return { type: RESET.SUCCEEDED, payload: {} }
}

export function savePlan(currentPlan) {
  const savedPlan = { ...currentPlan }
  RememberCurrent(PERSIST_KEY, savedPlan);
  return { type: SUBMIT_PLAN.SUCCEEDED, payload: savedPlan }
}

export function loadPage() {
  return (dispatch, getState, { webApi }) => {
    const lastPlan = GetCurrent(PERSIST_KEY) 
    // || { ...initState.currentPlan };
    log.debug(lastPlan);
    dispatch({ type: LOAD_PAGE.STARTED, payload: {} })
    // dispatch({ type: LOAD_PAGE.SUCCEEDED, payload: { currentPlan: initState.currentPlan } })
    dispatch({ type: LOAD_PAGE.SUCCEEDED, payload: { currentPlan: lastPlan } })
    // quoteService.loandInitPage()
    //     .then(
    //         data => {
    //             dispatch({ type: LOADPAGE.SUCCEEDED, payload: { ...data.data, currentPlan:lastPlan} })
    //         },
    //         error => {
    //             dispatchWithNotification(dispatch, { type: SUBMITQUOTE.FAILED, payload: error });
    //         }
    //     )
  }
}

export function submitPlan(upgrade) {
  // let curr = GetCurrent(PERSIST_KEY) || initState.currentPlan;

  return (dispatch, getState, { webApi }) => {
    dispatch({ type: SUBMIT_PLAN.STARTED, payload: {} })
    dispatch({ type: SUBMIT_PLAN.SUCCEEDED, payload: { ...upgrade } });
    savePlan(upgrade);
    // quoteService.getPlan(amountPicked)
    //     .then(
    //         data => {
    //             dispatch({ type: SUBMITPlan.SUCCEEDED, payload: { ...Plan, ...data.data} })
    //         },
    //         error => {
    //             dispatchWithNotification(dispatch, { type: SUBMITPlan.FAILED, payload: error });
    //         }
    //     )
  }
}


// WEBPACK FOOTER //
// ./src/redux/Plan.js